import { render, staticRenderFns } from "./my-coach-team.vue?vue&type=template&id=764974d7&scoped=true&"
import script from "./my-coach-team.vue?vue&type=script&lang=js&"
export * from "./my-coach-team.vue?vue&type=script&lang=js&"
import style0 from "./my-coach-team.vue?vue&type=style&index=0&id=764974d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764974d7",
  null
  
)

export default component.exports